import { render, staticRenderFns } from "./indexOnly.vue?vue&type=template&id=a734acb6&scoped=true"
import script from "./indexOnly.vue?vue&type=script&lang=js"
export * from "./indexOnly.vue?vue&type=script&lang=js"
import style0 from "./indexOnly.vue?vue&type=style&index=0&id=a734acb6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a734acb6",
  null
  
)

export default component.exports